module.exports = __webpack_public_path__ + "static/media/Drivinganalysis.64adacd2.svg";